import React from 'react'
import Header from './Header'
import Footer from './Footer'
import titleicon from '../img/title-icon.png';
import about1 from '../img/background/back1.png';

import about from '../img/background/about.jpg';

export default function About() {
  return (
    <div>
         <Header />
        <div className="page_title aboutpage">
  <div className="container">
    <div className="row">
      <div className="col-md-12">
        <h5 className="page_tittle activeColor text-center text-uppercase">
          About US
        </h5>
       
      </div>
    </div>
  </div>
</div>
<div className="container">

   <div className="row">
  {/* Left Column (Content) */}
  <div className="col-md-12 col-lg-7 col-xl-8 order-0 order-lg-0">
    <div className="market-content-page">
      <div className="block">
        <div className="text-img-block" style={{textAlign:'justify', marginTop:'6%'}}>
          {/* <img className="img-fluid" src={about} alt="" /> */}
          <h3 className="services-right-title">About TRACS</h3>
          <p>
           Founded in 1999 following a management buyout of Air International Transit’s Western Australian operations,
            The TRACS Group has grown into one of Western Australia’s most trusted providers of air conditioning and mechanical services.
             Headquartered in Perth, we deliver innovative and reliable HVAC solutions across diverse sectors, including commercial, industrial, and residential projects. With over two decades of experience, our reputation is built on technical expertise, quality workmanship, and a deep commitment to understanding and meeting our clients’ unique needs.
          </p>
          <p>
            Our comprehensive in-house capabilities—from mechanical design and engineering to ductwork 
            and pipework installation—ensure seamless, turnkey service delivery. Utilizing advanced technologies like 3D drafting and BIM coordination, we excel in managing complex, architecturally demanding projects, including remote mining and industrial sites. Supported by dedicated project management and maintenance teams, TRACS guarantees efficiency, consistency, and responsive ongoing support, 
            making us a preferred partner in delivering innovative climate solutions across Western Austral
          </p>
        </div>

        <div className="pt-lg-4">
          <h6 className="sub-title mb-4" style={{textAlign:'left'}}>Our Divisions</h6>
        </div>

       <div className="row" style={{textAlign:'left'}}>
<ul>
  <li>TRACS Air Conditioning (Commercial & Residential HVAC) </li>
  <li>Truck and Trailer Refrigeration </li>
  <li>Bus and Rail Air Conditioning </li>
  <li>Mining and Construction Equipment HVAC</li>
  <li>HVAC Maintenance Services</li>
</ul>

       </div>
      </div> {/* block end */}
    </div> {/* market-content-page end */}
  </div>

  {/* Right Column (Image) */}
  <div className="col-md-12 col-lg-5 col-xl-4 order-1 order-lg-1">
    <div className="right-image-wrapper text-center">
        <div className="market-content-page">
      <div className="block">
        <div className="text-img-block" style={{textAlign:'justify', marginTop:'21%'}}>
      <img
        className="img-fluid rounded shadow"
        src={about}
        alt="Power and Energy"
      />
    </div>
    </div>
    </div>
    </div>
  </div>
</div>



{/* Why Choose Us section */}
<div className="why-choose-us">
  <div className="container">
    <div className="row">
      <div className="col-md-12">
        <div className="section-title">
          <div className="section-thumb">
            <img src={titleicon} alt="title icon" />
          </div>
          <div className="section-body">
            <h6 className="sub-title activeColor">Why</h6>
            <h3 className="m-0 main-title">Choose Us</h3>
          </div>
        </div>
      </div>

      <div className="col-md-6 mb-3 mb-md-0">
        <div id="skill-bars-area">

          <div className="skill-bar">
  <div className="skill-info">
    <p className="skill-title">Customer Satisfaction</p>
    <p className="skill-percent">100%</p>
  </div>
  <div className="progress">
    <div className="progress-fill" style={{ width: "100%" }}></div>
  </div>
</div>

<div className="skill-bar">
  <div className="skill-info">
    <p className="skill-title">On-Time Project Delivery</p>
    <p className="skill-percent">98%</p>
  </div>
  <div className="progress">
    <div className="progress-fill" style={{ width: "98%" }}></div>
  </div>
</div>

<div className="skill-bar">
  <div className="skill-info">
    <p className="skill-title">System Reliability</p>
    <p className="skill-percent">97%</p>
  </div>
  <div className="progress">
    <div className="progress-fill" style={{ width: "97%" }}></div>
  </div>
</div>

<div className="skill-bar">
  <div className="skill-info">
    <p className="skill-title">Energy Efficiency Solutions</p>
    <p className="skill-percent">95%</p>
  </div>
  <div className="progress">
    <div className="progress-fill" style={{ width: "95%" }}></div>
  </div>
</div>

<div className="skill-bar">
  <div className="skill-info">
    <p className="skill-title">After-Sales Support</p>
    <p className="skill-percent">96%</p>
  </div>
  <div className="progress">
    <div className="progress-fill" style={{ width: "96%" }}></div>
  </div>
</div>

         

         

        

        
        </div>
      </div>


<div className="col-md-6">
 
  <div className="media wow fadeInUp animated" data-wow-delay="100ms" data-wow-duration="1500ms">
    <div className="company-icon">
      <i className="fas fa-award"></i>
    </div>
    <div className="media-body">
      <div>
        <h6 className="mb-1 sub-title">Established Legacy</h6>
        <p className="m-0">Over 25 years of proven performance across WA</p>
      </div>
    </div>
  </div>


  <div className="media wow fadeInUp animated" data-wow-delay="100ms" data-wow-duration="1500ms">
    <div className="company-icon">
      <i className="fas fa-tools"></i>
    </div>
    <div className="media-body">
      <div>
        <h6 className="mb-1 sub-title">In-House Expertise</h6>
        <p className="m-0">Engineering, drafting, and installation all under one roof</p>
      </div>
    </div>
  </div>


  <div className="media wow fadeInUp animated" data-wow-delay="100ms" data-wow-duration="1500ms">
    <div className="company-icon">
      <i className="fas fa-shield-alt"></i>
    </div>
    <div className="media-body">
      <div>
        <h6 className="mb-1 sub-title">Safety & Compliance</h6>
        <p>Adherence to strict OHS and environmental standards</p>
      </div>
    </div>
  </div>

  
  <div className="media wow fadeInUp animated" data-wow-delay="100ms" data-wow-duration="1500ms">
    <div className="company-icon">
      <i className="fas fa-project-diagram"></i>
    </div>
    <div className="media-body">
      <div>
        <h6 className="mb-1 sub-title">End-to-End Service</h6>
        <p>From concept design through to maintenance support</p>
      </div>
    </div>
  </div>

 
  <div className="media wow fadeInUp animated" data-wow-delay="100ms" data-wow-duration="1500ms">
    <div className="company-icon">
      <i className="fas fa-arrows-alt"></i>
    </div>
    <div className="media-body">
      <div>
        <h6 className="mb-1 sub-title">Responsive & Scalable</h6>
        <p>Agile team structure to meet both small and large project demands</p>
      </div>
    </div>
  </div>
</div>

      {/* <div className="col-md-6">
        <div
          className="media wow fadeInUp animated"
          data-wow-delay="100ms"
          data-wow-duration="1500ms"
        >
          <div className="company-icon">
            <i className="dustrial-icon flaticon-award"></i>
          </div>
          <div className="media-body">
            <div>
              <h6 className="mb-1 sub-title">Established Legacy</h6>
              <p className="m-0">
                 Over 25 years of proven performance across WA 
              </p>
            </div>
          </div>
        </div>

        <div
          className="media wow fadeInUp animated"
          data-wow-delay="100ms"
          data-wow-duration="1500ms"
        >
          <div className="company-icon">
            <i className="dustrial-icon flaticon-wheel"></i>
          </div>
          <div className="media-body">
            <div>
              <h6 className="mb-1 sub-title">In-House Expertise</h6>
              <p className="m-0">
                Engineering, drafting, and installation all under one roof 
              </p>
            </div>
          </div>
        </div>

        <div
          className="media wow fadeInUp animated"
          data-wow-delay="100ms"
          data-wow-duration="1500ms"
        >
          <div className="company-icon">
            <i className="dustrial-icon flaticon-solution"></i>
          </div>
          <div className="media-body">
            <div>
              <h6 className="mb-1 sub-title">Safety & Compliance</h6>
              <p>
                 Adherence to strict OHS and environmental standards
              </p>
            </div>
          </div>
        </div>
          <div
          className="media wow fadeInUp animated"
          data-wow-delay="100ms"
          data-wow-duration="1500ms"
        >
          <div className="company-icon">
            <i className="dustrial-icon flaticon-solution"></i>
          </div>
          <div className="media-body">
            <div>
              <h6 className="mb-1 sub-title">End-to-End Service</h6>
              <p>
                From concept design through to maintenance support 
              </p>
            </div>
          </div>
        </div>
          <div
          className="media wow fadeInUp animated"
          data-wow-delay="100ms"
          data-wow-duration="1500ms"
        >
          <div className="company-icon">
            <i className="dustrial-icon flaticon-solution"></i>
          </div>
          <div className="media-body">
            <div>
              <h6 className="mb-1 sub-title">Responsive & Scalable</h6>
              <p>
                 Agile team structure to meet both small and large project demands
              </p>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  </div>
</div>



<div className="about-management">
  <div className="container">
    <div className="row">
      <div className="col-md-12">
        <div className="section-title">
          <div className="section-thumb">
            <img src={titleicon} alt="title icon" />
          </div>
          <div className="section-body">
            <h6 className="sub-title activeColor">Meet Our</h6>
            <h3 className="m-0 main-title">Management</h3>
          </div>
        </div>
      </div>
    </div>

    <div className="row">
      {/* Team Member 1 */}
      <div className="team-item col-12 col-md-6 col-lg-4">
        <div className="card rounded-0 border-0">
          <div className="team-thumb position-relative p-3">
            {/* <img className="card-img-top" src={eby} alt="Team Member" /> */}
            <p className="team-description">

              Eby John Joseph leads the company with 17+ years of experience in the HVAC industry.
               Starting as an HVAC Engineer in the UAE, he has built expertise in estimation, design,
                project management, and value engineering. Holding a Bachelor's in Mechanical Engineering and Chartered Professional Engineer (CPEng) status in Australia, Eby combines technical excellence with strategic leadership to deliver high-quality, efficient projects that exceed client expectations.
              </p>
     <div className="team-social d-flex">
              <a href="#" className="ct-facebook d-flex justify-content-center align-items-center">
                <i className="fab fa-facebook-f" aria-hidden="true"></i>
              </a>
              <a href="#" className="ct-twitter d-flex justify-content-center align-items-center">
                <i className="fab fa-twitter" aria-hidden="true"></i>
              </a>
              <a href="#" className="ct-linkedin d-flex justify-content-center align-items-center">
                <i className="fab fa-linkedin-in" aria-hidden="true"></i>
              </a>
              <a href="#" className="ct-skype d-flex justify-content-center align-items-center">
                <i className="fab fa-skype" aria-hidden="true"></i>
              </a>
            </div>
          </div>
          <div className="card-body">
            <h5 className="card-title mb-0">Eby John Joseph</h5>
            <p className="card-text">General Manager</p>
          </div>
        </div>
      </div>

      {/* Team Member 2 */}
     <div className="team-item col-12 col-md-6 col-lg-4">
        <div className="card rounded-0 border-0">
          <div className="team-thumb position-relative p-3">
            {/* <img className="card-img-top" src={eby} alt="Team Member" /> */}
            <p className="team-description">

             Shane Holmes has 16+ years of experience in construction, specializing in project management and technical expertise. As a qualified refrigeration technician, he has led successful multi-million dollar projects across Western Australia, including high-rises and large commercial developments. Known for his results-driven leadership, Shane ensures projects are completed on time, within budget,
              and to the highest quality standards, prioritizing both safety and craftsmanship.</p>
     <div className="team-social d-flex">
              <a href="#" className="ct-facebook d-flex justify-content-center align-items-center">
                <i className="fab fa-facebook-f" aria-hidden="true"></i>
              </a>
              <a href="#" className="ct-twitter d-flex justify-content-center align-items-center">
                <i className="fab fa-twitter" aria-hidden="true"></i>
              </a>
              <a href="#" className="ct-linkedin d-flex justify-content-center align-items-center">
                <i className="fab fa-linkedin-in" aria-hidden="true"></i>
              </a>
              <a href="#" className="ct-skype d-flex justify-content-center align-items-center">
                <i className="fab fa-skype" aria-hidden="true"></i>
              </a>
            </div>
          </div>
          <div className="card-body">
            <h5 className="card-title mb-0">Shane Holmes</h5>
            <p className="card-text">Construction Manager</p>
          </div>
        </div>
      </div>

      {/* Team Member 3 */}
      <div className="team-item col-12 col-md-6 col-lg-4">
        <div className="card rounded-0 border-0">
          <div className="team-thumb position-relative p-3">
            {/* <img className="card-img-top" src={eby} alt="Team Member" /> */}
            <p className="team-description">

             Steven Daljac is a skilled Project Manager with over 15 years of experience in the construction industry. A qualified electrician, he has led multi-million dollar projects across Western Australia, including residential, commercial, and infrastructure developments. His technical background, combined with strong leadership and coordination skills, enables him to manage complex builds efficiently. Steven is known for his commitment to quality, 
             safety, and client satisfaction—delivering projects on time and beyond expectations.</p>
<div className="team-social d-flex">
              <a href="#" className="ct-facebook d-flex justify-content-center align-items-center">
                <i className="fab fa-facebook-f" aria-hidden="true"></i>
              </a>
              <a href="#" className="ct-twitter d-flex justify-content-center align-items-center">
                <i className="fab fa-twitter" aria-hidden="true"></i>
              </a>
              <a href="#" className="ct-linkedin d-flex justify-content-center align-items-center">
                <i className="fab fa-linkedin-in" aria-hidden="true"></i>
              </a>
              <a href="#" className="ct-skype d-flex justify-content-center align-items-center">
                <i className="fab fa-skype" aria-hidden="true"></i>
              </a>
            </div>
          </div>
          <div className="card-body">
            <h5 className="card-title mb-0">Steven Daljac</h5>
            <p className="card-text">Project Manager</p>
          </div>
        </div>
      </div>

      {/* Team Member 4 */}
     
    </div>

    <div className="row">
      {/* Team Member 1 */}
      <div className="team-item col-12 col-md-6 col-lg-4">
        <div className="card rounded-0 border-0">
          <div className="team-thumb position-relative p-3">
            {/* <img className="card-img-top" src={eby} alt="Team Member" /> */}
            <p className="team-description">

             Keith Palethorpe is a Project Manager with 20+ years in the HVAC industry, specializing in complex duct installations across diverse projects. He has successfully delivered multi-million dollar projects in both metropolitan Perth and regional mining sites. Known for his technical expertise and problem-solving skills, Keith excels in managing demanding conditions while maintaining high standards of safety, quality, 
             and efficiency, ensuring projects are completed on time and to specification. </p>
     <div className="team-social d-flex">
              <a href="#" className="ct-facebook d-flex justify-content-center align-items-center">
                <i className="fab fa-facebook-f" aria-hidden="true"></i>
              </a>
              <a href="#" className="ct-twitter d-flex justify-content-center align-items-center">
                <i className="fab fa-twitter" aria-hidden="true"></i>
              </a>
              <a href="#" className="ct-linkedin d-flex justify-content-center align-items-center">
                <i className="fab fa-linkedin-in" aria-hidden="true"></i>
              </a>
              <a href="#" className="ct-skype d-flex justify-content-center align-items-center">
                <i className="fab fa-skype" aria-hidden="true"></i>
              </a>
            </div>
          </div>
          <div className="card-body">
            <h5 className="card-title mb-0">Keith Palethorpe</h5>
            <p className="card-text">Project Manager</p>
          </div>
        </div>
      </div>

      {/* Team Member 2 */}
     <div className="team-item col-12 col-md-6 col-lg-4">
        <div className="card rounded-0 border-0">
          <div className="team-thumb position-relative p-3">
            {/* <img className="card-img-top" src={eby} alt="Team Member" /> */}
            <p className="team-description">

              Troy Slynn is a Project Supervisor with 15+ years in the mechanical services industry. A qualified refrigeration technician, he specializes in pipework installations and is known for delivering high-quality results on commercial and industrial projects. With hands-on leadership, Troy efficiently manages multiple trades, ensuring smooth coordination, timely delivery, and strict adherence to safety and quality standards.
               His technical expertise and team-focused approach make him an asset on complex, fast-paced sites.
            </p>
     <div className="team-social d-flex">
              <a href="#" className="ct-facebook d-flex justify-content-center align-items-center">
                <i className="fab fa-facebook-f" aria-hidden="true"></i>
              </a>
              <a href="#" className="ct-twitter d-flex justify-content-center align-items-center">
                <i className="fab fa-twitter" aria-hidden="true"></i>
              </a>
              <a href="#" className="ct-linkedin d-flex justify-content-center align-items-center">
                <i className="fab fa-linkedin-in" aria-hidden="true"></i>
              </a>
              <a href="#" className="ct-skype d-flex justify-content-center align-items-center">
                <i className="fab fa-skype" aria-hidden="true"></i>
              </a>
            </div>
          </div>
          <div className="card-body">
            <h5 className="card-title mb-0">Troy Slynn</h5>
            <p className="card-text">Project Supervisor</p>
          </div>
        </div>
      </div>

      {/* Team Member 3 */}
    

      {/* Team Member 4 */}
     
    </div>
  </div>
</div>



</div>




         <Footer />
    </div>
  )
}
